// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"0969eb00","332":"0969eb00","711":"0969eb00"}[chunkId] + ".chunk.css";
};